import React from 'react';

import Icon from '../../../components/AppIcon';

const SearchBar = ({ searchTerm, onSearchChange, resultCount }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-6 mb-6 shadow-sm">
      <div className="relative">
        <div className="absolute left-3 top-1/2 -translate-y-1/2">
          <Icon name="Search" size={20} color="#6B7280" />
        </div>
        <input
          type="text"
          placeholder="Rechercher par nom d'établissement, ville, ou programme..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full h-12 pl-11 pr-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-800 placeholder:text-gray-400"
        />
      </div>
      {searchTerm && (
        <div className="mt-3 flex items-center justify-between">
          <p className="text-sm text-gray-600">
            <span className="font-semibold text-blue-600">{resultCount}</span> résultat(s) pour "{searchTerm}"
          </p>
          <button
            onClick={() => onSearchChange('')}
            className="text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1"
          >
            <Icon name="X" size={16} />
            Effacer
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchBar;